const url = '/cities';
const Provider = 'Cities';
const dbModel = 'Cities';

export { url, Provider, dbModel };
